/** @format */
import { post } from '@root/utils/httpWrap';
// 充电品牌管理列表
export const chargingPileList = (params: any): any => {
  return post('/bangdao/saasapi/v1/chargingPile/pageList', params);
};
//充电品牌新增/bangdao/saasapi/v1/chargingPile/create
export const chargingPileCreate = (params: any): any => {
  return post('/bangdao/saasapi/v1/chargingPile/create', params);
};
//充电品牌详情/bangdao/saasapi/v1/chargingPile/detail
export const chargingPileDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/chargingPile/detail', params);
};
//充电品牌编辑
export const chargingPileEdit = (params: any): any => {
  return post('/bangdao/saasapi/v1/chargingPile/edit', params);
};
//充电品牌启用禁用 /bangdao/saasapi/v1/chargingPile/editStatus
export const chargingPileEditStatus = (params: any): any => {
  return post('/bangdao/saasapi/v1/chargingPile/editStatus', params);
};
// 充电记录列表
export const chargeRecordList = (params: any): any => {
  return post('bangdao/saasapi/v1/chargingPileRecord/pageList', params);
};
//充电优惠列表
export const chargeDiscountList = (params: any): any => {
  return post('/bangdao/saasapi/v1/chargeDiscount/pageList', params);
};
//充电品牌列表
export const chargingList = (params: any): any => {
  return post('/bangdao/saasapi/v1/chargingPile/list', params);
};
//充电品牌查询
export const chargingPileBrand = (params: any): any => {
  return post('/bangdao/saasapi/v1/chargingPileBrand/queryBrand', params);
};
//充电品牌创建
export const createBrand = (params: any): any => {
  return post('/bangdao/saasapi/v1/chargingPileBrand/createBrand', params);
};
